import React, {useContext} from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InfinityMediaItemConfigContext from '~/App/Modules/MyLibrary/Context/infinite-media-item-config-context';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';
import { Tooltip } from '@vimily/bonjoro-ui-components-v2/Tooltip';

export interface TagPillProps {
  label: string;
  bgColor: string;
  selected?: boolean;
  onClick?(): void;
  onDeleteClick?(): void;
  className?: string;
  truncateCharactersCount?: number;
}

const Container = styled.div<Pick<TagPillProps, 'bgColor'>>`
  ${({ bgColor }) => `
    background-color: ${bgColor}80;

    &:hover {
      background-color: ${bgColor};
    }
  `}
`;

const Label = styled.span<Pick<TagPillProps, 'truncateCharactersCount'>>`
  ${({truncateCharactersCount}) => `
    max-width: ${truncateCharactersCount?? 20}ch;
  `}
`;

export function TagPill({
  label,
  bgColor,
  selected = false,
  onClick,
  onDeleteClick,
  className,
  truncateCharactersCount = 20
}: TagPillProps) {

  const itemConfig = useContext(InfinityMediaItemConfigContext);
  const { selectMode} = itemConfig;

  const pill = (
    <Container
      bgColor={bgColor}
      className={cx(
        'flex items-center gap-x-[5px]',
        'px-2.5 py-0.5',
        'h-5 rounded-[20px] cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <Label className={
        cx(
          'text-xs text-neutral-700 truncate'
        )
      }
        truncateCharactersCount={truncateCharactersCount}
      >{label}</Label>
      {selected && !selectMode && (
        <FontAwesomeIcon
          className='text-neutral-500 hover:text-pink-900'
          icon={faTimes}
          width={10}
          height={10}
          onClick={onDeleteClick}
        />
      )}
    </Container>
  );

  if (label.length > truncateCharactersCount) {
    return <Tooltip
      content={label}
      className='text-lg z-[9999]'
      positions={['top']}
    >
      {pill}
    </Tooltip>;
  } else {
    return pill;
  }
}
